import React, { FC, useEffect, useState } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import s from './AboutUs.module.scss'
import { Link } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import { BACKEND_URL } from '../../../api'

const videoAnimation = {
    hidden: { scale: 0.5, opacity: 0 },
    visible: {
        scale: 1,
        opacity: 1,
        transition: { duration: 0.8 }
    }
}

const textAnimation = {
    hidden: { opacity: 0, x: 100 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.8, delay: 0.2 }
    }
}

const AboutUs: FC = () => {
    const { info } = useAppSelector(state => state.info)
    const videoControls = useAnimation()
    const textControls = useAnimation()
    const { ref, inView } = useInView({ threshold: 0.1 })
    const [hasAnimated, setHasAnimated] = useState(false)

    useEffect(() => {
        if (inView && !hasAnimated) {
            videoControls.start('visible')
            textControls.start('visible')
            setHasAnimated(true)
        }
    }, [videoControls, textControls, inView, hasAnimated])


    return (
        <section className={s.section} ref={ref}>
            <div
                className={s.imageWrapper}
            >
                {(info?.about_us_picture.src && <img className={s.picture} src={BACKEND_URL + info?.about_us_picture.src} alt='phoenix-programs || О нас img' />)}
               
            </div>

            <div className={`${s.container} container`}>
                <div
                    className={s.content}
                >
                    <h2 className='title'><span /> О НАС</h2>
                    <article className={s.article}>
                        {info?.about_us_article}
                    </article>
                </div>
            </div>
            <span className='lineGradient bottom-line' />
            <div className={s.shape_left} />
        </section>
    )
}

export default AboutUs
